(async () => typeof window < "u" && (window.React || (window.React = await import("react")), window.ReactDOM || (window.ReactDOM = await import("react-dom"))))();
(function() {
  if (window.cadesplugin) return;
  let C, O = 0, p, D, N = 0, d = 0, M = 0, L = 0;
  const c = !!window.Promise;
  let e;
  c ? e = new Promise((t, _) => {
    D = t, p = _;
  }) : e = {};
  function G() {
    const t = navigator.userAgent;
    let _, n = t.match(
      /(opera|yabrowser|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
    ) || [];
    return /trident/i.test(n[1]) ? (_ = /\brv[ :]+(\d+)/g.exec(t) || [], { name: "IE", version: _[1] || "" }) : n[1] === "Chrome" && (_ = t.match(/\b(OPR|Edg|YaBrowser)\/(\d+)/), _ != null) ? { name: _[1].replace("OPR", "Opera"), version: _[2] } : (n = n[2] ? [n[1], n[2]] : [navigator.appName, navigator.appVersion, "-?"], (_ = t.match(/version\/(\d+)/i)) != null && n.splice(1, 1, _[1]), { name: n[0], version: n[1] });
  }
  const i = G();
  function u(t, _) {
    typeof console > "u" || t <= e.current_log_level && (t === e.LOG_LEVEL_DEBUG && console.log("DEBUG: %s", _), t === e.LOG_LEVEL_INFO && console.info("INFO: %s", _), t === e.LOG_LEVEL_ERROR && console.error("ERROR: %s", _));
  }
  function w(t) {
    if (!(t === e.LOG_LEVEL_DEBUG || t === e.LOG_LEVEL_INFO || t === e.LOG_LEVEL_ERROR)) {
      u(
        e.LOG_LEVEL_ERROR,
        `cadesplugin_api.js: Incorrect log_level: ${t}`
      );
      return;
    }
    e.current_log_level = t, e.current_log_level === e.LOG_LEVEL_DEBUG && u(
      e.LOG_LEVEL_INFO,
      "cadesplugin_api.js: log_level = DEBUG"
    ), e.current_log_level === e.LOG_LEVEL_INFO && u(
      e.LOG_LEVEL_INFO,
      "cadesplugin_api.js: log_level = INFO"
    ), e.current_log_level === e.LOG_LEVEL_ERROR && u(
      e.LOG_LEVEL_INFO,
      "cadesplugin_api.js: log_level = ERROR"
    ), A() && (e.current_log_level === e.LOG_LEVEL_DEBUG && window.postMessage("set_log_level=debug", "*"), e.current_log_level === e.LOG_LEVEL_INFO && window.postMessage("set_log_level=info", "*"), e.current_log_level === e.LOG_LEVEL_ERROR && window.postMessage("set_log_level=error", "*"));
  }
  function x() {
    e.CAPICOM_MEMORY_STORE = 0, e.CAPICOM_LOCAL_MACHINE_STORE = 1, e.CAPICOM_CURRENT_USER_STORE = 2, e.CADESCOM_MEMORY_STORE = 0, e.CADESCOM_LOCAL_MACHINE_STORE = 1, e.CADESCOM_CURRENT_USER_STORE = 2, e.CADESCOM_CONTAINER_STORE = 100, e.CAPICOM_MY_STORE = "My", e.CAPICOM_STORE_OPEN_MAXIMUM_ALLOWED = 2, e.CAPICOM_CERTIFICATE_FIND_SUBJECT_NAME = 1, e.CADESCOM_XML_SIGNATURE_TYPE_ENVELOPED = 0, e.CADESCOM_XML_SIGNATURE_TYPE_ENVELOPING = 1, e.CADESCOM_XML_SIGNATURE_TYPE_TEMPLATE = 2, e.CADESCOM_XADES_DEFAULT = 16, e.CADESCOM_XADES_BES = 32, e.CADESCOM_XADES_T = 80, e.CADESCOM_XADES_X_LONG_TYPE_1 = 1488, e.CADESCOM_XMLDSIG_TYPE = 0, e.XmlDsigGost3410UrlObsolete = "http://www.w3.org/2001/04/xmldsig-more#gostr34102001-gostr3411", e.XmlDsigGost3411UrlObsolete = "http://www.w3.org/2001/04/xmldsig-more#gostr3411", e.XmlDsigGost3410Url = "urn:ietf:params:xml:ns:cpxmlsec:algorithms:gostr34102001-gostr3411", e.XmlDsigGost3411Url = "urn:ietf:params:xml:ns:cpxmlsec:algorithms:gostr3411", e.XmlDsigGost3411Url2012256 = "urn:ietf:params:xml:ns:cpxmlsec:algorithms:gostr34112012-256", e.XmlDsigGost3410Url2012256 = "urn:ietf:params:xml:ns:cpxmlsec:algorithms:gostr34102012-gostr34112012-256", e.XmlDsigGost3411Url2012512 = "urn:ietf:params:xml:ns:cpxmlsec:algorithms:gostr34112012-512", e.XmlDsigGost3410Url2012512 = "urn:ietf:params:xml:ns:cpxmlsec:algorithms:gostr34102012-gostr34112012-512", e.CADESCOM_CADES_DEFAULT = 0, e.CADESCOM_CADES_BES = 1, e.CADESCOM_CADES_T = 5, e.CADESCOM_CADES_X_LONG_TYPE_1 = 93, e.CADESCOM_PKCS7_TYPE = 65535, e.CADESCOM_ENCODE_BASE64 = 0, e.CADESCOM_ENCODE_BINARY = 1, e.CADESCOM_ENCODE_ANY = -1, e.CAPICOM_CERTIFICATE_INCLUDE_CHAIN_EXCEPT_ROOT = 0, e.CAPICOM_CERTIFICATE_INCLUDE_WHOLE_CHAIN = 1, e.CAPICOM_CERTIFICATE_INCLUDE_END_ENTITY_ONLY = 2, e.CAPICOM_CERT_INFO_SUBJECT_SIMPLE_NAME = 0, e.CAPICOM_CERT_INFO_ISSUER_SIMPLE_NAME = 1, e.CAPICOM_CERTIFICATE_FIND_SHA1_HASH = 0, e.CAPICOM_CERTIFICATE_FIND_SUBJECT_NAME = 1, e.CAPICOM_CERTIFICATE_FIND_ISSUER_NAME = 2, e.CAPICOM_CERTIFICATE_FIND_ROOT_NAME = 3, e.CAPICOM_CERTIFICATE_FIND_TEMPLATE_NAME = 4, e.CAPICOM_CERTIFICATE_FIND_EXTENSION = 5, e.CAPICOM_CERTIFICATE_FIND_EXTENDED_PROPERTY = 6, e.CAPICOM_CERTIFICATE_FIND_APPLICATION_POLICY = 7, e.CAPICOM_CERTIFICATE_FIND_CERTIFICATE_POLICY = 8, e.CAPICOM_CERTIFICATE_FIND_TIME_VALID = 9, e.CAPICOM_CERTIFICATE_FIND_TIME_NOT_YET_VALID = 10, e.CAPICOM_CERTIFICATE_FIND_TIME_EXPIRED = 11, e.CAPICOM_CERTIFICATE_FIND_KEY_USAGE = 12, e.CAPICOM_DIGITAL_SIGNATURE_KEY_USAGE = 128, e.CAPICOM_PROPID_ENHKEY_USAGE = 9, e.CAPICOM_OID_OTHER = 0, e.CAPICOM_OID_KEY_USAGE_EXTENSION = 10, e.CAPICOM_EKU_CLIENT_AUTH = 2, e.CAPICOM_EKU_SMARTCARD_LOGON = 5, e.CAPICOM_EKU_OTHER = 0, e.CAPICOM_AUTHENTICATED_ATTRIBUTE_SIGNING_TIME = 0, e.CAPICOM_AUTHENTICATED_ATTRIBUTE_DOCUMENT_NAME = 1, e.CAPICOM_AUTHENTICATED_ATTRIBUTE_DOCUMENT_DESCRIPTION = 2, e.CADESCOM_AUTHENTICATED_ATTRIBUTE_SIGNING_TIME = 0, e.CADESCOM_AUTHENTICATED_ATTRIBUTE_DOCUMENT_NAME = 1, e.CADESCOM_AUTHENTICATED_ATTRIBUTE_DOCUMENT_DESCRIPTION = 2, e.CADESCOM_ATTRIBUTE_OTHER = -1, e.CADESCOM_STRING_TO_UCS2LE = 0, e.CADESCOM_BASE64_TO_BINARY = 1, e.CADESCOM_DISPLAY_DATA_NONE = 0, e.CADESCOM_DISPLAY_DATA_CONTENT = 1, e.CADESCOM_DISPLAY_DATA_ATTRIBUTE = 2, e.CADESCOM_ENCRYPTION_ALGORITHM_RC2 = 0, e.CADESCOM_ENCRYPTION_ALGORITHM_RC4 = 1, e.CADESCOM_ENCRYPTION_ALGORITHM_DES = 2, e.CADESCOM_ENCRYPTION_ALGORITHM_3DES = 3, e.CADESCOM_ENCRYPTION_ALGORITHM_AES = 4, e.CADESCOM_ENCRYPTION_ALGORITHM_GOST_28147_89 = 25, e.CADESCOM_HASH_ALGORITHM_SHA1 = 0, e.CADESCOM_HASH_ALGORITHM_MD2 = 1, e.CADESCOM_HASH_ALGORITHM_MD4 = 2, e.CADESCOM_HASH_ALGORITHM_MD5 = 3, e.CADESCOM_HASH_ALGORITHM_SHA_256 = 4, e.CADESCOM_HASH_ALGORITHM_SHA_384 = 5, e.CADESCOM_HASH_ALGORITHM_SHA_512 = 6, e.CADESCOM_HASH_ALGORITHM_CP_GOST_3411 = 100, e.CADESCOM_HASH_ALGORITHM_CP_GOST_3411_2012_256 = 101, e.CADESCOM_HASH_ALGORITHM_CP_GOST_3411_2012_512 = 102, e.CADESCOM_HASH_ALGORITHM_CP_GOST_3411_HMAC = 110, e.CADESCOM_HASH_ALGORITHM_CP_GOST_3411_2012_256_HMAC = 111, e.CADESCOM_HASH_ALGORITHM_CP_GOST_3411_2012_512_HMAC = 112, e.LOG_LEVEL_DEBUG = 4, e.LOG_LEVEL_INFO = 2, e.LOG_LEVEL_ERROR = 1, e.CADESCOM_AllowNone = 0, e.CADESCOM_AllowNoOutstandingRequest = 1, e.CADESCOM_AllowUntrustedCertificate = 2, e.CADESCOM_AllowUntrustedRoot = 4, e.CADESCOM_SkipInstallToStore = 268435456, e.ENABLE_CARRIER_TYPE_CSP = 1, e.ENABLE_CARRIER_TYPE_FKC_NO_SM = 2, e.ENABLE_CARRIER_TYPE_FKC_SM = 4, e.ENABLE_ANY_CARRIER_TYPE = 7, e.DISABLE_EVERY_CARRIER_OPERATION = 0, e.ENABLE_CARRIER_OPEN_ENUM = 1, e.ENABLE_CARRIER_CREATE = 2, e.ENABLE_ANY_OPERATION = 3, e.CADESCOM_PRODUCT_CSP = 0, e.CADESCOM_PRODUCT_OCSP = 1, e.CADESCOM_PRODUCT_TSP = 2, e.MEDIA_TYPE_REGISTRY = 1, e.MEDIA_TYPE_HDIMAGE = 2, e.MEDIA_TYPE_CLOUD = 4, e.MEDIA_TYPE_SCARD = 8;
  }
  function H(t) {
    function _(o, s) {
      let a;
      try {
        a = n[o](s);
      } catch (S) {
        return Promise.reject(S);
      }
      return a.done ? a.value : Promise.resolve(a.value).then(r, l);
    }
    var n = t(Array.prototype.slice.call(arguments, 1)), r = _.bind(_, "next"), l = _.bind(_, "throw");
    return r();
  }
  function I() {
    return i.name === "IE" || i.name === "MSIE";
  }
  function P() {
    return navigator.userAgent.match(/ipod/i) || navigator.userAgent.match(/ipad/i) || navigator.userAgent.match(/iphone/i);
  }
  function A() {
    if (I()) return !1;
    if (i.name === "Edg")
      return !0;
    if (i.name === "YaBrowser")
      return L = !0, !0;
    if (i.name === "Opera")
      return N = !0, i.version >= 33;
    if (i.name === "Firefox")
      return d = !0, i.version >= 52;
    if (i.name === "Chrome")
      return i.version >= 42;
    if (i.name === "Safari")
      return M = !0, i.version >= 12;
  }
  function b(t) {
    if (P())
      return Y("CreateObject", [t]);
    if (I()) {
      if (t.match(/X509Enrollment/i))
        try {
          return document.getElementById("webClassFactory").CreateObject(t);
        } catch {
          try {
            var _ = document.getElementById(
              "certEnrollClassFactory"
            );
            return _.CreateObject(t);
          } catch {
            throw "Для создания обьектов X509Enrollment следует настроить веб-узел на использование проверки подлинности по протоколу HTTPS";
          }
        }
      try {
        var _ = document.getElementById("webClassFactory");
        return _.CreateObject(t);
      } catch {
        return new ActiveXObject(t);
      }
    }
    return C.CreateObject(t);
  }
  function v(t) {
    return t < 0 && (t = 4294967295 + t + 1), t.toString(16).toUpperCase();
  }
  function y(t) {
    let _ = t.message;
    return _ ? t.number && (_ += ` (0x${v(t.number)})`) : _ = t, _;
  }
  function U(t) {
    if (A() || I() || P())
      return y(t);
    try {
      return C.getLastError();
    } catch {
      return y(t);
    }
  }
  function F() {
    return cpcsp_chrome_nmcades.ReleasePluginObjects();
  }
  function B(t) {
    return C.CreateObjectAsync(t);
  }
  var T = {
    callbacksCount: 1,
    callbacks: {},
    // Automatically called by native layer when a result is available
    resultForCallback: function(_, n) {
      const r = T.callbacks[_];
      r && r.apply(null, n);
    },
    // Use this in javascript to request native objective-c code
    // functionName : string (I think the name is explicit :p)
    // args : array of arguments
    // callback : function with n-arguments that is going to be called when the native code returned
    call: function(_, n, r) {
      const l = r && typeof r == "function", o = l ? T.callbacksCount++ : 0;
      l && (T.callbacks[o] = r);
      let s = document.createElement("IFRAME");
      const a = new Array("_CPNP_handle");
      try {
        s.setAttribute(
          "src",
          `cpnp-js-call:${_}:${o}:${encodeURIComponent(JSON.stringify(n, a))}`
        );
      } catch (S) {
        alert(S);
      }
      document.documentElement.appendChild(s), s.parentNode.removeChild(s), s = null;
    }
  };
  function Y(t, _) {
    let n, r;
    if (T.call(
      t,
      _,
      (l, o) => {
        r = l;
        try {
          n = JSON.parse(o);
        } catch {
          n = o;
        }
        typeof n == "string" && (n = n.replace(/\\\n/gm, `
`), n = n.replace(/\\\r/gm, "\r"));
      }
    ), r) throw r;
    return n;
  }
  function j() {
    if (!window.cadesplugin_skip_extension_install) {
      const t = document.createElement("div");
      t.id = "cadesplugin_ovr", t.style = "visibility: hidden; position: fixed; left: 0px; top: 0px; width:100%; height:100%; background-color: rgba(0,0,0,0.7)", t.innerHTML = "<div id='cadesplugin_ovr_item' style='position:relative; width:400px; margin:100px auto; background-color:#fff; border:2px solid #000; padding:10px; text-align:center; opacity: 1; z-index: 1500'><button id='cadesplugin_close_install' style='float: right; font-size: 10px; background: transparent; border: 1; margin: -5px'>X</button><p>Для работы КриптоПро ЭЦП Browser plugin на данном сайте необходимо расширение для браузера. Убедитесь, что оно у Вас включено или установите его.<p><a href='https://www.cryptopro.ru/sites/default/files/products/cades/extensions/firefox_cryptopro_extension_latest.xpi'>Скачать расширение</a></p></div>", document.getElementsByTagName("Body")[0].appendChild(t), document.getElementById("cadesplugin_close_install").addEventListener("click", () => {
        E("Плагин недоступен"), document.getElementById("cadesplugin_ovr").style.visibility = "hidden";
      }), t.addEventListener("click", () => {
        E("Плагин недоступен"), document.getElementById("cadesplugin_ovr").style.visibility = "hidden";
      }), t.style.visibility = "visible";
    }
  }
  function V() {
    cpcsp_chrome_nmcades.check_chrome_plugin(
      R,
      E
    );
  }
  function f() {
    window.postMessage("cadesplugin_echo_request", "*"), window.addEventListener(
      "message",
      (t) => {
        if (!(typeof t.data != "string" || !t.data.match("cadesplugin_loaded")))
          if (d || M) {
            const _ = t.data.substring(t.data.indexOf("url:") + 4), n = document.createElement("script");
            n.setAttribute("type", "text/javascript"), n.setAttribute("src", _), n.onerror = E, n.onload = V, document.getElementsByTagName("head")[0].appendChild(n);
          } else
            cpcsp_chrome_nmcades.check_chrome_plugin(
              R,
              E
            );
      },
      !1
    );
  }
  function X() {
    if (d || M)
      f();
    else if (N || L) {
      var t = document.createElement("script");
      t.setAttribute("type", "text/javascript"), t.setAttribute(
        "src",
        "chrome-extension://epebfcehmdedogndhlcacafjaacknbcm/nmcades_plugin_api.js"
      ), t.onerror = E, t.onload = f, document.getElementsByTagName("head")[0].appendChild(t);
    } else {
      var t = document.createElement("script");
      t.setAttribute("type", "text/javascript"), t.setAttribute(
        "src",
        "chrome-extension://iifchhfnnmpdbibifmljnfjhpififfog/nmcades_plugin_api.js"
      ), t.onerror = E, t.onload = f, document.getElementsByTagName("head")[0].appendChild(t);
    }
  }
  function g() {
    const t = document.createElement("object");
    if (t.setAttribute("id", "cadesplugin_object"), t.setAttribute("type", "application/x-cades"), t.setAttribute("style", "visibility: hidden"), document.getElementsByTagName("body")[0].appendChild(t), C = document.getElementById("cadesplugin_object"), I()) {
      const _ = document.createElement("object");
      _.setAttribute("id", "certEnrollClassFactory"), _.setAttribute(
        "classid",
        "clsid:884e2049-217d-11da-b2a4-000e7bbb2b09"
      ), _.setAttribute("style", "visibility: hidden"), document.getElementsByTagName("body")[0].appendChild(_);
      const n = document.createElement("object");
      n.setAttribute("id", "webClassFactory"), n.setAttribute(
        "classid",
        "clsid:B04C8637-10BD-484E-B0DA-B8A039F60024"
      ), n.setAttribute("style", "visibility: hidden"), document.getElementsByTagName("body")[0].appendChild(n);
    }
  }
  function R() {
    O = 1, c ? D() : window.postMessage("cadesplugin_loaded", "*");
  }
  function E(t) {
    (typeof t > "u" || typeof t == "object") && (t = "Плагин недоступен"), O = 1, c ? p(t) : window.postMessage("cadesplugin_load_error", "*");
  }
  function h() {
    O !== 1 && (d && j(), O = 1, c ? p("Истекло время ожидания загрузки плагина") : window.postMessage("cadesplugin_load_error", "*"));
  }
  function m() {
    try {
      const t = b("CAdESCOM.About");
      R();
    } catch {
      document.getElementById("cadesplugin_object").style.display = "none";
      const _ = navigator.mimeTypes["application/x-cades"];
      if (_) {
        const n = _.enabledPlugin;
        E(n ? "Плагин загружен, но не создаются обьекты" : "Ошибка при загрузке плагина");
      } else
        E("Плагин недоступен");
    }
  }
  function k() {
    const t = document.createElement("div");
    if (t.innerHTML = "<!--[if lt IE 9]><i></i><![endif]-->", t.getElementsByTagName("i").length === 1) {
      E(
        "Internet Explorer версии 8 и ниже не поддерживается"
      );
      return;
    }
    A() ? X() : c ? document.readyState === "complete" ? (g(), m()) : window.addEventListener(
      "load",
      (n) => {
        g(), m();
      },
      !1
    ) : window.addEventListener(
      "message",
      (n) => {
        n.data === "cadesplugin_echo_request" && (g(), m());
      },
      !1
    );
  }
  function K(t) {
    C = t;
  }
  function J() {
    return !!(typeof e.EnableInternalCSP < "u" && e.EnableInternalCSP);
  }
  e.JSModuleVersion = "2.3.0", e.async_spawn = H, e.set = K, e.set_log_level = w, e.getLastError = U, e.is_capilite_enabled = J, A() && (e.CreateObjectAsync = B, e.ReleasePluginObjects = F), A() || (e.CreateObject = b), window.cadesplugin_load_timeout ? setTimeout(h, window.cadesplugin_load_timeout) : setTimeout(h, 2e4), x(), e.current_log_level = e.LOG_LEVEL_ERROR, window.cadesplugin = e, k();
})();
